import React, { useContext, useEffect, useState } from 'react';
import { Environment } from '../interfaces/Environment';
import { Settings } from '../interfaces/Settings';

const initialEnvironment: Environment<Settings> = {
  isLoaded: false,
  moduleName: '',
  settings: {
    apiBaseURL: '',
    environment: '',
    appInsightsKey: '',
    ocpApimKey: '',
    cdnBaseUrl: '',
  },
};

const EnvironmentContext =
  React.createContext<Environment<Settings>>(initialEnvironment);

interface EnvironmentContextProviderProps {
  moduleName: string;
  baseUrl?: string;
  children?: React.ReactNode;
}

export const EnvironmentProvider = <T extends Settings>(
  props: EnvironmentContextProviderProps
) => {
  const [environment, setEnvironment] = useState<Environment<T>>(
    initialEnvironment as Environment<T>
  );

  const appSettingsUrl = props.baseUrl
    ? `${props.baseUrl}/appSettings.json`
    : '/appSettings.json';

  useEffect(() => {
    fetch(appSettingsUrl)
      .then((response) => {
        return response.json();
      })
      .then(function (appSettings) {
        setEnvironment({
          isLoaded: true,
          moduleName: props.moduleName,
          settings: appSettings,
        });
      });
    /* eslint-disable-next-line */
  }, []);
  return (
    <EnvironmentContext.Provider value={environment}>
      {environment.isLoaded && props.children}
    </EnvironmentContext.Provider>
  );
};

export const useEnvironment = () => useContext(EnvironmentContext);
